import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.label !== null ? _c('Label', {
    attrs: {
      "bold": ""
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), !!_vm.options.length ? [_c(VSelect, {
    ref: _vm.refBusca,
    class: _vm.inputClass,
    attrs: {
      "label": _vm.labelBusca,
      "value": _vm.value,
      "filterable": _vm.filterable,
      "options": _vm.options
    },
    on: {
      "search": _vm.handleSearch,
      "input": _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return !!_vm.options ? [_vm._t("options", null, {
          "data": option
        })] : undefined;
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._t("selected", null, {
          "data": option
        })];
      }
    }], null, true)
  })] : [_c(VSelect, {
    class: _vm.inputClass,
    attrs: {
      "label": _vm.labelBusca,
      "filterable": _vm.filterable,
      "options": _vm.newRegister
    },
    on: {
      "search": _vm.handleSearch,
      "input": _vm.register
    },
    scopedSlots: _vm._u([{
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._t("selected", null, {
          "data": option
        })];
      }
    }], null, true)
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };